import graphqlClient from "../../api/axios_interceptor";
import {
    mpesaStkMutation
} from "../../api/graphql/queries/mpesa"
import { MPESA_STK } from "../actions/actionTypes";
import { updateActionErrors } from "./updateErrors";

const mpesaMiddleware =storeAPI => next => async action => {
    let mpesaInfo = action.payload;

    switch(action.type){
        case MPESA_STK:
            try {
                await graphqlClient({
                    data: {
                        query: mpesaStkMutation( mpesaInfo.paymentItem, mpesaInfo.phoneNumber, mpesaInfo.amount )
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else if (queryResult.data.data.sendStkPush.success === false) {
                        let error = queryResult.data.data.sendStkPush.errorMessage;
                        action = updateActionErrors(action, error);
                    }

                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;
    }
    return next(action);
}

export{
    mpesaMiddleware
}